module.exports = __webpack_public_path__ + "img/1-4.b3ccfbc0.jpg";